import ApiHelper from "./ApiHelper";

class AuthService {
  static async SignIn(body) {
    return ApiHelper.postAnonymous("/admin/login", body);
  }
  static async editAdmin(data) {
    return ApiHelper.postAnonymous("/admin/edit", data);
  }
  static async loginInfo(data) {
    return ApiHelper.postAnonymous("/admin/login-logs/get/all", data);
  }
  static async resetUserPassword(data) {
    return ApiHelper.postAnonymous("/admin/password/reset", data);
  }
  static async verifyOtp(data) {
    return ApiHelper.postAnonymous("/admin/verify-otp", data);
  }
  static async resendOtp(data) {
    return ApiHelper.postAnonymous("/admin/resend-otp", data);
  }
}
export default AuthService;
